/** Signal-bar durations currently admitted by Alpha Atlas. */
export const ALPHA_ATLAS_SIGNAL_DURATIONS = ['1d', '240m', '30m'];
/** Return family measured from an Alpha Atlas signal. */
export const ALPHA_ATLAS_OUTCOME_KINDS = ['underlying', 'option'];
/** Atlas uses the same underlying identity for direct and option outcomes. */
export const ALPHA_ATLAS_ENTITY_TYPES = ['Asset', 'AssetIndex'];
//# sourceMappingURL=AlphaAtlasTypes.js.map